// 代理前缀
const proxyPrefix = 'zhunxing'

// 准星接口
export const ZHUNXINGAPI = `/${proxyPrefix}/resapi/activity/mget`

// 订阅模版 id
export const ACTIVITY_ID = 'train_ticket_message'
// 分享订阅模版 id
export const SHARE_ACTIVITY_ID = 'train_speed_message'
// 分享模版 id
export const SHARE_ID = 'train_share'
// 首页分享模版 id
export const HOME_SHARE_ID = 'train_home_share'
